import { Search } from 'lucide-react'
import { Input } from '@/components/ui/input'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import type { FiltrosNotificaciones } from '@/modules/notificaciones/types'
import { TIPOS_NOTIFICACION } from '@/modules/notificaciones/types'

interface NotificacionesFiltersProps {
  filtros: FiltrosNotificaciones
  onFiltrosChange: (filtros: FiltrosNotificaciones) => void
}

export function NotificacionesFilters({ filtros, onFiltrosChange }: NotificacionesFiltersProps) {
  return (
    <div className="flex flex-wrap gap-4">
      {/* Búsqueda */}
      <div className="flex-1 min-w-[200px]">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            placeholder="Buscar por campaña, marca..."
            className="pl-10"
            value={filtros.search || ''}
            onChange={(e) => onFiltrosChange({ ...filtros, search: e.target.value, page: 1 })}
          />
        </div>
      </div>

      {/* Fecha desde */}
      <Input
        type="date"
        className="w-[160px]"
        value={filtros.fecha_desde || ''}
        onChange={(e) => onFiltrosChange({ ...filtros, fecha_desde: e.target.value, page: 1 })}
        placeholder="Desde"
      />

      {/* Fecha hasta */}
      <Input
        type="date"
        className="w-[160px]"
        value={filtros.fecha_hasta || ''}
        onChange={(e) => onFiltrosChange({ ...filtros, fecha_hasta: e.target.value, page: 1 })}
        placeholder="Hasta"
      />

      {/* Tipo */}
      <Select
        value={filtros.tipo || 'all'}
        onValueChange={(value) =>
          onFiltrosChange({ ...filtros, tipo: value === 'all' ? '' : value as any, page: 1 })
        }
      >
        <SelectTrigger className="w-[180px]">
          <SelectValue placeholder="Tipo" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los tipos</SelectItem>
          {TIPOS_NOTIFICACION.map((tipo) => (
            <SelectItem key={tipo.value} value={tipo.value}>
              {tipo.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>

      {/* Estado de lectura */}
      <Select
        value={filtros.leida || 'all'}
        onValueChange={(value) =>
          onFiltrosChange({ ...filtros, leida: value === 'all' ? '' : value as any, page: 1 })
        }
      >
        <SelectTrigger className="w-[160px]">
          <SelectValue placeholder="Estado" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todas</SelectItem>
          <SelectItem value="no_leidas">No leídas</SelectItem>
          <SelectItem value="leidas">Leídas</SelectItem>
        </SelectContent>
      </Select>
    </div>
  )
}
